import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const authorizeNetSettings = defineIntegrationSettings({
  fields: { enabled: z.boolean(), sandboxMode: z.boolean() },
  secrets: {
    loginId: z.string().trim().min(1, "Login ID is required"),
    transactionKey: z.string().trim().min(1, "Transaction key is required"),
  },
  connectOnly: {},
  computed: {},
});
